import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Icon, Input } from '@components/atomic';
import { COLOR_BORDER, COLOR_FONT_GRAY, COLOR_FONT_POINT } from '@assets/color';

const AuthContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const AuthInputWrapper = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${COLOR_BORDER};
  align-items: center;
  padding: 10px 20px;
`;

const ErrorMsg = styled.div`
  margin-top: 5px;
  color: ${COLOR_FONT_POINT};
  font-size: 12px;
  text-align: left;
`;

const AuthInput = ({
  icnUrl,
  placeholder,
  type,
  onChange,
  errorMessage,
  ...props
}) => {
  return (
    <AuthContainer>
      <AuthInputWrapper>
        <Icon src={icnUrl} size="20px" />
        <Input
          inputType="form"
          style={{ border: 'none', color: `${COLOR_FONT_GRAY}` }}
          textSize={16}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          {...props}
        />
      </AuthInputWrapper>
      <ErrorMsg>{errorMessage}</ErrorMsg>
    </AuthContainer>
  );
};

AuthInput.propTypes = {
  icnUrl: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default AuthInput;
